module.exports = __webpack_public_path__ + "img/illustration_ch.81bcadc9.png";